<p-toast position="top-right"></p-toast>

<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <!--<p-sidebar [(visible)]="visibleUserFilter" position="right" [baseZIndex]="10000">
        <disciplinary-filter [homeDisciplinaryComponent]="this"></disciplinary-filter>
    </p-sidebar>-->
    <!--<p-sidebar [(visible)]="showInfoPopup" position="right" [baseZIndex]="10000" [style]="{width:'40em'}">
        <disciplinary-info [_disciplinary]="disciplinaryInfo"></disciplinary-info>
        <ng-template pTemplate="header">
            <span class="order-detail-title__text">Disciplinary ID:&nbsp;</span>
            <span class="order-detail-title__id">{{disciplinaryInfo.Id}}</span>
        </ng-template>
    </p-sidebar>-->

    <add-or-update-disciplinary *ngIf="showAddOrUpdateDisciplinarySideBar"
                                [showAddOrUpdateDisciplinarySideBar]="showAddOrUpdateDisciplinarySideBar"
                                [representativeFullName]="representativeFullName"
                                [homeDisciplinaryComponent]="this"
                                (changedShowAddOrUpdateDisciplinarySideBarEmit)="changedShowAddOrUpdateDisciplinarySideBarEmit($event)"></add-or-update-disciplinary>

    <disciplinary-detail *ngIf="showDisciplinaryDetailSideBar"
                         [_disciplinaryId]="disciplinaryId"
                         [showDisciplinaryDetailSideBar]="showDisciplinaryDetailSideBar"
                         (changedShowDisciplinaryDetailSideBarEmit)="changedShowDisciplinaryDetailSideBarEmit($event)"></disciplinary-detail>

    <disciplinary-investigation *ngIf="showDisciplinaryInvestigationSideBar"
                                [homeDisciplinaryComponent]="this"
                                [_disciplinaryId]="disciplinaryId"
                                [showDisciplinaryInvestigationSideBar]="showDisciplinaryInvestigationSideBar"
                                (changedShowDisciplinaryInvestigationSideBarEmit)="changedShowDisciplinaryInvestigationSideBarEmit($event)"></disciplinary-investigation>


    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="card">
        <div class="onboarding-head">
            <div class="onboarding-head-fleft">
                <div class="onboarding-head-title">
                    {{onboardingTitle}}
                </div>
            </div>
            <div class="flex flex-row onboarding-head-right">
                <div class="onboarding-head-date">
                    <p-calendar [(ngModel)]="filterDisciplinaryRangeDate" [showIcon]="true" selectionMode="range"
                                [dateFormat]="'dd M yy'" (ngModelChange)="handleHeaderFilterChange($event)"></p-calendar>
                </div>
                <div style="width: 285px; margin-left: 20px">
                    <p-dropdown [options]="arrayFilterServiceType" placeholder="Please Select"
                                optionLabel="name" optionValue="value" [(ngModel)]="disciplinaryHeaderSearch.serviceType"
                                (ngModelChange)="handleHeaderFilterChange($event)"></p-dropdown>
                </div>
                <div class="ml-4" *ngIf="homeMenuActive === homeMenuEnum.DisciplinaryNewCases">
                    <button class="btn-darkblue" pButton (click)="openAddOrUpdateDisciplinarySideBar()">Add New</button>
                </div>
                <div class="ml-4 mt-1">
                    <column-selector #columnSelector
                         [defaultColumns]="defaultCols"
                         (selectedColumnsChange)="onSelectedColumnsChange($event)"
                         [tableName]="onboardingTitle"
                         [(selectedColumns)]="cols">
                    </column-selector>
                </div>
            </div>
        </div>

        <p-table #ridersGrid
                 [columns]="cols"
                 [value]="xpressDisciplinaries"
                 [lazy]="true"
                 (onLazyLoad)="handleLazyLoad($event)"
                 responsiveLayout="scroll" dataKey="Id"
                 [paginator]="true"
                 [loading]="loading"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [showFirstLastIcon]="false"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [style]="{height: 'calc(100vh - 180px)'}">
            <ng-template pTemplate="caption">
                <div class="flex flex-row sp-header">
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        <div class="sortable-header">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" class="onboarding-column-sorticon"></p-sortIcon>
                        </div>
                    </th>
                </tr>
                <tr>
                    <ng-container *ngFor="let item of cols">
                        <th class="overflow-unset">
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Inputs">
                                <input type="text" pInputText placeholder="{{item.placeholder}}" [(ngModel)]="disciplinaryHeaderSearch[item.model]"
                                       (input)="handleHeaderFilterChange($event)" />
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.InputNumber">
                                <p-inputNumber inputId="integeronly" placeholder="{{item.placeholder}}" [(ngModel)]="disciplinaryHeaderSearch[item.model]"
                                               (ngModelChange)="handleHeaderFilterChange($event)"> </p-inputNumber>
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Dropdown">
                                <ng-container *ngIf="item.take === 'obj'; else dropdown">
                                    <p-dropdown [options]="item.options" placeholder="{{item.placeholder}}"
                                                optionLabel="name" [(ngModel)]="disciplinaryHeaderSearch[item.model]"
                                                (ngModelChange)="handleHeaderFilterChange($event)"></p-dropdown>
                                </ng-container>
                                <ng-template #dropdown>
                                    <p-dropdown [options]="item.options" placeholder="{{item.placeholder}}"
                                                optionLabel="name" optionValue="value" [(ngModel)]="disciplinaryHeaderSearch[item.model]"
                                                (ngModelChange)="handleHeaderFilterChange($event)"></p-dropdown>
                                </ng-template>
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Calendar">
                                <p-calendar [(ngModel)]="disciplinaryHeaderSearch[item.model]"
                                            [showIcon]="true"
                                            placeholder="{{item.placeholder}}"
                                            dateFormat="dd M yy"
                                            (ngModelChange)="handleHeaderFilterChange($event)" />
                            </ng-container>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-disciplinary>
                <tr [pSelectableRow]="disciplinary">
                    <td class="ui-resizable-column" *ngFor="let item of cols">
                        <ng-container [ngSwitch]="item.name">
                            <ng-container *ngSwitchCase="'DisciplinaryStatusText'">
                                <div class="onbg-status-col m-auto"
                                      [style.color]="disciplinary.StatusColor"
                                      [style.background-color]="disciplinary.StatusBackColor"
                                      (click)="openDisciplinarySideBar(disciplinary)">
                                    {{disciplinary.DisciplinaryStatusText}}
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'PriorityTypeId'">
                                <div class="flex-row">
                                    <img style="margin-right: 10px;" [src]="disciplinary.PriorityIconUrl" />
                                    <p-dropdown class="priority-col" placeholder="Priority" [(ngModel)]="disciplinary.PriorityTypeId" [options]="priorityTypeList"
                                                optionLabel="name" optionValue="value" (ngModelChange)="changePriority(disciplinary, $event)"></p-dropdown>
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'DisciplinaryId'">
                                D-{{disciplinary.DisciplinaryId}}
                            </ng-container>
                            <ng-container *ngSwitchCase="'OffenseTypeText'">
                                <span (click)="op.toggle($event)" style="cursor: pointer;">{{disciplinary.CodeText}}</span>
                                <p-overlayPanel #op>
                                    <div class="overlay-panel-disciplinary">
                                        <div class="overlay-panel-disciplinary-head">
                                            <div>Code: <span class="overlay-panel-disciplinary-head__code">{{disciplinary.CodeText}}</span></div>
                                        </div>
                                        <div class="overlay-panel-disciplinary-content">
                                            <div class="overlay-panel-disciplinary-content__title">PROHIBITED ACTS</div>
                                            <div class="overlay-panel-disciplinary-content__text">{{disciplinary.ProhibitedAct}}</div>
                                        </div>
                                    </div>
                                </p-overlayPanel>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <span class="ui-resizable-column">
                                    {{disciplinary[item.name]}}
                                </span>
                            </ng-container>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="xpressDisciplinaries.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + xpressDisciplinaries.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>
</div>
